import { apiServices } from '../services/api.services';
import store from '../store';

const deviceNameValid = /^[\p{L} \-\d]{0,24}$/u;

export const editDeviceName = (name) => {
    if (!deviceNameValid.test(name)) return false;
    const { modal } = store.getState().devices;
    return async (Dispatch) => {
        var type = "";
        switch (modal.type) {
            case 'alarm' :
                type = "ALARM_UPDATE_PART";
                break;
            case 'storage':
                type = "STORAGE_MODAL_UPDATE";
                break;
            default:
                type = "SWITCH_UPDATE_PART";
        }
        await apiServices.post("/updateDevice", { id: modal.id, name }).then(() => {
            Dispatch({type, id: modal.id, part: "name", value: name});
            Dispatch({type: "DEVICES_MODAL_RESET"});
        }).catch(err => {
            return err;
        });
    };
}

export const closeModal = () => {
    return async (Dispatch) => {
        Dispatch({type: "DEVICES_MODAL_RESET"});
    };
}